import React,{Component} from "react";
import { Modal, Icon } from 'antd';
import ReactGA from 'react-ga';
export default class Approved extends Component {
    constructor(props){
        super(props);
        this.state = {
            active: true,
          }
          this.goto = this.goto.bind(this)
    }

  componentDidMount() {
    let amount = this.props.price
    window.fbq('track', 'Purchase', {
      value: amount,
      currency: 'USD',
    });
    ReactGA.event({
      category: 'User',
      action: 'Purchase',
      label: 'User Interaction',
      value: amount
    });
  }

  openModal =  (active)=> this.setState({ active });

  goto(e){
    this.props.history.push('/')
  }
  
  render() {
    return (
      <div>
        <Modal
          centered
          footer={null}
          closable={false}
          visible={this.state.active}
        >
          <div className="xpayment-approved">
            <Icon type="check-circle" className="response" />
             <h4>Thank you for your order</h4>
             <p>
             Woot! You successfully made a payment with Stripe.
            <br />We just sent your receipt to your email address.
             </p>
             <div className="xaction">
                <button onClick={this.goto}>
                    Continue <Icon type="arrow-right" />
                </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
